import {MyInfo} from '../../api/type.client';
import {MyInfoVo} from '../../common/shared/api/nicolas/vo/inven/MyInfoVo.interface';

export function createMyInfo(myInfo: MyInfoVo): MyInfo {
  return {
    cashBalance: myInfo.cash_balance,
    nickname: myInfo.nickname,
    numUnusedGift: myInfo.num_unused_gift,
    profileImg: myInfo.profile_img,
    useCashPassVip: myInfo.use_cash_pass_vip,
    autoPaymentInfo: myInfo.auto_payment_info
      ? {
          isBatchPayment: myInfo.auto_payment_info.is_batch_payment,
          cashPassVip: myInfo.auto_payment_info.cash_pass_vip,
          batchPaymentCategory: myInfo.auto_payment_info.batch_payment_category,
          batchPaymentType: myInfo.auto_payment_info.batch_payment_type,
        }
      : undefined,
  };
}
